// Terminology Implementation 术语转化
let terminologyMap = null;
let reg = null;

export function setTerminologyMap(newRuleMap) {
    terminologyMap = newRuleMap || {};
    let words = Object.keys(terminologyMap);
    if (!words.length) {
        reg = null;
        return;
    }
    reg = new RegExp(words.map(word => `\\b${word}\\b`).join('|'), 'g');
}
export function replaceTerminology(sentense) {
    if (!reg) {
        return sentense;
    }
    return sentense.replace(reg, function (matcheStr) {
        return terminologyMap[matcheStr];
    });
}
